export default {
  nav: {
    auction: "Public Auction",
    ecosystem: "The Ecosystem",
    areas: "Project Areas",
    naming: "Naming Rights & Alliances",
    contact: "Private Contact",
    cta: "Request Confidential Dossier",
  },
  hero: {
    eyebrow: "Montalbán · Caracas · Venezuela",
    badge: "Fundación Deportiva Disimil",
    lines: [
      "The New Epicenter",
      "of Sports, Health and",
      "Professional Training",
      "in Caracas",
    ],
    subtitle:
      "A strategic alliance in Montalbán that transforms the territory into a high-performance complex, higher technical education and preventive medicine.",
    ctaPrimary: "Naming Rights Opportunities",
    ctaSecondary: "Explore the Areas",
    scroll: "Scroll",
  },
  marquee: [
    "Naming Rights Available",
    "Montalbán · Caracas",
    "High Performance Center",
    "Mcintosh Sports Academy",
    "Institute of Higher Sports Studies",
    "Cryotherapy & Hydrotherapy",
    "Public Naming Auction",
    "Fundación Deportiva Disimil",
  ],
  eco: {
    chapter: "01",
    label: "The Ecosystem",
    title: "A four-part ecosystem. Four investment fronts.",
    subtitle:
      "Four institutions integrated under a single governance, each with exclusive corporate partnership opportunities.",
    opportunityLabel: "Partnership opportunity",
    cards: [
      {
        num: "01",
        category: "Athletic Infrastructure",
        title: "Montalbán High Performance Sports Center",
        desc: "Main synthetic turf field, LED night lighting towers, professional locker rooms and high-performance gym.",
        opportunity: "Main Naming Rights of the Complex",
        badge: "Sports Axis",
        testid: "ecosystem-card-alto-rendimiento",
      },
      {
        num: "02",
        category: "Grassroots Development",
        title: "Mcintosh Sports Academy",
        desc: "Youth academy and comprehensive sports development for hundreds of children and young athletes in the community.",
        opportunity: "Academy & Uniforms Patron",
        badge: "Development Axis",
        testid: "ecosystem-card-mcintosh",
      },
      {
        num: "03",
        category: "Academic Education",
        title: "Institute of Higher Sports Studies Venezuela",
        desc: "Smart certification classrooms for coaches, referees and sports managers from across the country.",
        opportunity: "Headline Academic Sponsor",
        badge: "Education Axis",
        testid: "ecosystem-card-instituto",
      },
      {
        num: "04",
        category: "Health & Therapy",
        title: "Disimil Sports Rehabilitation Center",
        desc: "Medical offices, physical therapy rooms, advanced physiotherapy and specialized cryotherapy and hydrotherapy suites.",
        opportunity:
          "Health Area Naming — ideal for clinics, insurers and pharmaceutical brands",
        badge: "Medical Axis",
        testid: "ecosystem-card-rehabilitacion",
      },
    ],
  },
  trans: {
    chapter: "02",
    label: "Project Areas",
    statement: "From disused space to a continental icon.",
    title: "The starting point: a territory with history, ready to be reborn",
    subtitle:
      "Current record of the complex in Montalbán. This material — captured on site — shows the scale of the space the master plan will transform in phases.",
    videoLabel: "Video record",
    videoCaption: "This is how the complex looks today — on-site footage, Montalbán",
    captions: [
      "Aerial view of the site — north sector",
      "Aerial view of the site — south sector",
      "Main field — current state",
      "Dirt pitch — current training ground",
    ],
    note: "Phased master plan: recovery of the main field, LED towers, clinical pavilion and institute classrooms. Technical specifications are detailed in the Executive Dossier.",
  },
  plan: {
    chapter: "03",
    label: "Master Plan",
    title: "The master plan: this is how the complex can look",
    subtitle:
      "Original conceptual plan of the project. Nine zones planned across the Montalbán site — each with individual naming available.",
    mapCaption: "Conceptual plan — original project design",
    zonesTitle: "Master plan zones",
    zones: [
      {
        name: "Pitch 1",
        desc: "Main synthetic turf field with LED night lighting towers.",
      },
      {
        name: "Pitch 2",
        desc: "Second regulation field for simultaneous training and tournaments.",
      },
      {
        name: "Studies Center",
        desc: "Home of the Institute of Higher Sports Studies Venezuela.",
      },
      {
        name: "Therapeutic Center",
        desc: "Physiotherapy, cryotherapy and hydrotherapy suites of the Disimil Rehabilitation Center.",
      },
      {
        name: "Medical Center",
        desc: "Medical offices and specialized sports care.",
      },
      {
        name: "Gym",
        desc: "High-performance gym and biomechanical conditioning.",
      },
      {
        name: "Offices",
        desc: "Administrative headquarters of Fundación Deportiva Disimil and the Technical Board.",
      },
      {
        name: "Cafeteria",
        desc: "Recreation and hospitality area for athletes, families and corporate visitors.",
      },
      {
        name: "Parking",
        desc: "Parking for athletes, medical staff and visitors.",
      },
    ],
    note: "Each zone accepts individual naming, equipment sponsorship or full phase adoption.",
  },
  naming: {
    chapter: "04",
    label: "Naming Rights & Alliances",
    title: "Link your brand's name to a historic legacy",
    subtitle:
      "Institutional partnership models designed to maximize reputational return. No public figures: terms are reserved for the executive table.",
    closing:
      "Terms, advertising return specifications and technical requirements are delivered privately in an executive meeting.",
    packages: [
      {
        badge: "Flagship Opportunity",
        title: "Headline Naming Rights of the Complex",
        framing: "Public auction · closes Dec 31, 2026",
        highlights: [
          "Right to name the entire venue: '[Your Brand] Sports Complex'",
          "Monumental presence on the main facade and center circle of the field",
          "Brand on accreditations, broadcasts and official stationery",
          "Priority access to complex events and media tours",
        ],
        cta: "Join the Confidential Auction",
        testid: "pkg-naming-titular",
      },
      {
        badge: "Health & Insurance Sector",
        title: "Naming of the Clinical Pavilion & Cryotherapy Suite",
        framing: "Ideal for clinics, insurers and pharmaceutical companies",
        highlights: [
          "Brand presence in the physical recovery medical area",
          "Naming of cryotherapy and hydrotherapy suites",
          "Direct visibility to elite athletes and private patients",
          "Preferential care agreements for allied executives",
        ],
        cta: "Request the Health Area Dossier",
        testid: "pkg-naming-clinico",
      },
      {
        badge: "Corporate Education",
        title: "Academic Patron of the Institute",
        framing: "Leadership in national sports education",
        highlights: [
          "Brand presence in certification classrooms and laboratories",
          "Brand on official technical certificates issued by the institute",
          "Corporate scholarship program under your organization's name",
          "Co-organization of congresses and technical conferences",
        ],
        cta: "Schedule the Academic Presentation",
        testid: "pkg-padrino-academico",
      },
      {
        badge: "Builders & Brands",
        title: "Technical Allies & In-Kind Donations",
        framing: "Construction materials and equipment",
        highlights: [
          "Agreements with construction, lighting, cabling, steel, cement and paint companies",
          "Permanent recognition as Construction Ally on the honor plaque",
          "Corporate Social Responsibility contribution certification",
          "Visibility in technical areas during construction and operation",
        ],
        cta: "Coordinate an In-Kind Contribution",
        testid: "pkg-aliados-tecnicos",
      },
    ],
  },
  auction: {
    "chapter": "05",
    "label": "Naming Rights Public Auction",
    "title": "The complex's name, up for public auction",
    "subtitle": "Title naming rights for 10 years. The company or individual with the best offer at closing will name the Montalbán High-Performance Sports Center.",
    "closesLabel": "Auction closes",
    "closesDate": "December 31, 2026 · 6:00 pm (Venezuela time)",
    "days": "Days",
    "hours": "Hours",
    "minutes": "Min",
    "seconds": "Sec",
    "leaderLabel": "Current leading bidder",
    "noBids": "No bids yet — be the first",
    "bidsLabel": "Bids received",
    "biddersLabel": "Approved bidders",
    "termLabel": "Term",
    "termValue": "10 years",
    "rulesTitle": "Auction rules",
    "rules": [
      "Only bidders previously approved by the Technical Board may participate.",
      "Amounts are confidential: only approved bidders and the Technical Board know them. The public sees only the leading bidder and the number of bids.",
      "Each bidder chooses to appear with their name/company or with an alias.",
      "Anti-sniping rule: any bid in the last 10 minutes extends the auction by 10 more minutes.",
      "The winner signs a contract with the Foundation and pays by bank transfer, under international audit."
    ],
    "videoLabel": "How the world does it",
    "videoTitle": "Stadiums and arenas that carry a brand's name",
    "videoNote": "Allianz Arena, Emirates Stadium, Etihad Stadium, Mercedes-Benz Stadium, Estadio BBVA, Allianz Parque: global brands that turned a sports venue into their greatest showcase. Montalbán opens that same opportunity in Venezuela.",
    "ctaRegister": "Register as a Bidder",
    "ctaEnter": "Enter the Bidder Portal",
    "closed": "Auction closed",
    "open": "Auction open"
  },
  portal: {
    "back": "Back to site",
    "title": "Bidder Portal",
    "subtitle": "Naming Rights Public Auction · Montalbán Complex",
    "login": "Sign in",
    "register": "Register",
    "name": "Full name",
    "company": "Company (optional)",
    "email": "Email",
    "phone": "Phone / WhatsApp",
    "password": "Password (min. 8 characters)",
    "displayMode": "How do you want to appear publicly?",
    "showName": "My name or company",
    "showAlias": "An alias (Bidder #NN)",
    "submitLogin": "Sign in",
    "submitRegister": "Submit registration request",
    "logout": "Sign out",
    "pendingTitle": "Registration under review",
    "pendingDesc": "The Technical Board is verifying your request. You will receive an email once approved and able to place bids.",
    "rejectedTitle": "Registration not approved",
    "rejectedDesc": "Your request was not approved. If you believe this is an error, contact us through the contact form.",
    "yourAlias": "Your public identifier",
    "highBid": "Current leading bid",
    "minNext": "Minimum next bid",
    "noHigh": "No bids yet",
    "leading": "You lead the auction",
    "outbid": "Your bid has been outbid",
    "notBid": "You have not placed a bid yet",
    "bidLabel": "Your bid (USD)",
    "placeBid": "Place bid",
    "confirm": "Confirm your bid of {amount} USD? It is binding.",
    "bidOk": "Bid recorded",
    "extended": "The auction has been extended (anti-sniping rule).",
    "history": "Bid history",
    "mine": "You",
    "closed": "The auction has closed. Thank you for participating.",
    "closesIn": "Closes in",
    "welcome": "Welcome",
    "statusApproved": "Approved bidder"
  },
  gov: {
    chapter: "06",
    label: "Governance",
    title: "First-world governance and transparency",
    subtitle:
      "Every contribution is managed under technical supervision, international auditing and institutional accountability.",
    features: [
      {
        title: "Fundación Deportiva Disimil",
        desc: "Legal entity and governing body of the project: technical supervision and institutional management.",
      },
      {
        title: "International NGO Audit",
        desc: "All project funds will be audited by an independent international NGO, with periodic accountability to partners.",
      },
      {
        title: "Executive Technical Board",
        desc: "Engineers, sports physicians and project managers oversee each phase of the master plan.",
      },
      {
        title: "Exclusive Use of Contributions",
        desc: "Every contribution — in currency or in kind — is allocated exclusively to the development and operation of the complex.",
      },
    ],
  },
  contrib: {
    chapter: "07",
    label: "How to Contribute",
    title: "Official contribution channel",
    subtitle: "Direct, traceable and audited contributions. No intermediaries.",
    bankTitle: "Bank Deposit or Wire Transfer",
    bankDesc:
      "Official U.S. dollar (USD) banking coordinates are delivered together with the Confidential Executive Dossier, once your organization's request is validated.",
    bankFields: [
      "Correspondent bank",
      "Beneficiary: Fundación Deportiva Disimil",
      "U.S. dollar (USD) account",
      "Reference: Complejo Montalbán Project",
    ],
    bankCta: "Request Banking Coordinates",
    kindTitle: "In-Kind Donation",
    kindDesc:
      "Construction materials, LED lighting, steel, cement, paint, synthetic turf and medical or sports equipment.",
    kindCta: "Coordinate an In-Kind Donation",
    auditNote:
      "All contributions — monetary and in-kind — are audited by an international NGO and reported to each partner.",
  },
  donate: {
    badge: "Secure card payment",
    title: "Donate by Card",
    desc: "Direct, secure and traceable contribution in US dollars. Processed by Stripe under international payment-security certification.",
    once: "One-time Gift",
    monthly: "Monthly Ally",
    monthlyHint: "Recurring monthly charge. Cancel anytime.",
    amountLabel: "Select an amount (USD)",
    custom: "Other amount",
    customPlaceholder: "Amount in USD",
    nameLabel: "Name or company (optional)",
    namePlaceholder: "As you wish to appear on the Wall of Allies",
    emailLabel: "Email (for your receipt)",
    emailPlaceholder: "name@company.com",
    anonymous: "I want my donation to be anonymous",
    anonymousHint: "Your name will not be shown publicly. The receipt is sent to your email.",
    cta: "Donate by Card",
    ctaMonthly: "Become a Monthly Ally",
    redirecting: "Redirecting to secure checkout…",
    error: "Payment could not be started. Please try again.",
    amountError: "Enter a valid amount between 5 and 25,000 USD.",
    secure: "SSL encrypted · Your card details never touch our servers",
    wallLabel: "Wall of Allies",
    wallTitle: "Those already building Montalbán",
    wallEmpty: "Be the first name on this wall.",
    wallAnon: "anonymous gifts",
    wallMonthly: "Monthly Ally",
    wallCorporate: "Corporate allies who have already contributed",
    wallIndividual: "Individual allies",
    wallOnce: "Ally",
  },
  payment: {
    checking: "Confirming your contribution…",
    successTitle: "Thank you for building Montalbán",
    successDesc: "Your contribution has been received and will be recorded under international audit. A receipt has been sent to your email.",
    successMonthly: "Welcome as a Monthly Ally of the Montalbán Complex.",
    pendingTitle: "Payment processing",
    pendingDesc: "Your bank is confirming the transaction. We will notify you by email once completed.",
    failTitle: "We could not confirm the payment",
    failDesc: "The session expired or the payment was not completed. You may try again.",
    cancelTitle: "Payment cancelled",
    cancelDesc: "No charge was made. You can resume your contribution whenever you wish.",
    back: "Back to site",
    retry: "Try again",
  },
  contact: {
    chapter: "08",
    label: "Private Contact",
    title: "Schedule a presentation with the Technical Board",
    subtitle:
      "Every request is handled under a strict confidentiality agreement. Guaranteed executive response.",
    name: "Representative's Name",
    company: "Company or Institution",
    email: "Corporate Email",
    phone: "Direct Phone / WhatsApp",
    interest: "Area of Interest",
    interestPlaceholder: "Select an area",
    interests: [
      "General Complex Naming (Auction)",
      "Health Area / Cryotherapy",
      "Academic Area / Institute",
      "Construction Materials Donation",
      "General Alliance / Other",
    ],
    message: "Additional comments (optional)",
    submit: "Schedule Presentation with the Technical Board",
    submitting: "Sending request…",
    success:
      "Request sent successfully. The Technical Board will contact you shortly under a confidentiality agreement.",
    error: "The request could not be sent. Please try again.",
    privacy:
      "Your information is used exclusively for managing the project's institutional alliances.",
  },
  footer: {
    entity: "Fundación Deportiva Disimil",
    project: "Montalbán High Performance Sports Center",
    location: "Montalbán, Libertador Municipality, Caracas, Venezuela",
    confidentiality:
      "Documentation reserved exclusively for corporate and institutional partners.",
    navTitle: "Index",
    masterplan: "Master Plan",
    governance: "Governance",
    contribute: "How to Contribute",
    rights: "© 2026 Fundación Deportiva Disimil. All rights reserved.",
  },
};
